import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.modal.onfido_verification.title',
        defaultMessage: `Guarantor identity check`
    },
    subTitle: {
        id: '_.modal.onfido_verification.subTitle',
        defaultMessage: `We need to check your identity to make sure we’re sending money to the right person. We use Onfido verification, which is a secure way to do this. 

        You'll just need your passport or driving license, and your smartphone.
        `
    },
    subTitleMultiple: {
        id: '_.modal.onfido_verification.subTitleMultiple',
        defaultMessage: `We need to verify all guarantors’ identities to make sure we’re sending money to the right person and Onfido is the most secure way to do this.`
    },
    requirementsSubTitle: {
        id: '_.modal.onfido_verification.requirementsSubTitle',
        defaultMessage:
            'Select your mobile number and click to send yourself a text below. Once you receive the text, click on the link to complete your check.'
    },
    requirementsSubTitleMultiple: {
        id: '_.modal.onfido_verification.requirementsSubTitleMultiple',
        defaultMessage:
            'Select your mobile number below and click to send yourself a text, which will contain a link for you to complete the check. Do the same for the other guarantors so they can complete theirs too (and maybe give them a heads up to speed things along!).'
    },
    resendMessage: {
        id: '_.modal.onfido_verification.resend_message',
        defaultMessage: `Re-send SMS`
    },
    sendText: {
        id: '_.modal.onfido_verification.send',
        defaultMessage: `Send SMS`
    },
    close: {
        id: '_.modal.onfido_verification.close',
        defaultMessage: 'Close'
    },
    cancel: {
        id: '_.modal.onfido_verification.cancel',
        defaultMessage: 'Cancel'
    },
    save: {
        id: '_.modal.onfido_verification.save',
        defaultMessage: 'Save'
    },
    enterValidNumber: {
        id: '_.modal.onfido_verification.error.enter_valid_number',
        defaultMessage: 'Please enter a valid mobile number'
    },
    yourPhoneNumber: {
        id: '_.modal.onfido_verification.your_phone_number',
        defaultMessage: 'Your mobile'
    },
    addNew: {
        id: '_.modal.onfido_verification.add_new',
        defaultMessage: 'Add new'
    },
    didNotReceiveText: {
        id: '_.modal.onfido_verification.did_not_receive_text',
        defaultMessage: "Didn't receive it?"
    },
    continueText: {
        id: '_.modal.onfido_verification.continue',
        defaultMessage: 'Continue'
    },
    letsTryThatAgain: {
        id: '_.modal.onfido_verification.lets_try_that_again',
        defaultMessage: "Let's try that again!"
    },
    makeSureAllTextsSentInfo: {
        id: '_.modal.onfido_verification.make_sure_all_texts_sent_info',
        defaultMessage:
            'Please give us a call on {phoneNumber} if you need help completing this step'
    },
    makeSureAllTextsSentInfoMultiple: {
        id: '_.modal.onfido_verification.make_sure_all_texts_sent_info_multiple_guarantors',
        defaultMessage:
            'Please ensure all guarantors have completed the check. Give us a call on {phoneNumber} if you need help completing this step.'
    },
    somethingWentWrongInfo: {
        id: '_.modal.onfido_verification.something_went_wrong_info',
        defaultMessage:
            "Something's gone wrong! Please try again and make sure all guarantors have completed the check."
    },
    notStartedYet: {
        id: '_.modal.onfido_verification.not_started_yet',
        defaultMessage: 'Not started yet'
    },
    verified: {
        id: '_.modal.onfido_verification.verified',
        defaultMessage: 'Verified'
    },
    somethingWentWrong: {
        id: '_.modal.onfido_verification.something_went_wrong',
        defaultMessage:
            'Something went wrong - please send another SMS and try again'
    },
    verifyingYourCheck: {
        id: '_.modal.onfido_verification.verifying_check',
        defaultMessage: 'Verifying your check'
    },
    verifyingNameCheck: {
        id: '_.modal.onfido_verification.verifying_name_check',
        defaultMessage: 'Verifying {values} check'
    },
    smsFailed: {
        id: '_.modal.onfido_verification.sms_failed',
        defaultMessage:
            "Your SMS didn't go through. Please try it again by clicking 'Send SMS'."
    },
    reachedMaxOnfidoChecks: {
        id: '_.modal.onfido_verification.reached_max_onfido_checks',
        defaultMessage:
            'Please give your account manager a call on {phoneNumber} to continue.'
    },
    phoneNumber: {
        id: '_.modal.onfido_verification.phone_number',
        defaultMessage: '020 3778 0105'
    }
});
